import { useEffect, useRef } from 'react';

const useIntersectionObserver = (onIntersect: () => void, options?: IntersectionObserverInit): React.RefObject<Element | null> => {
  const elementRef = useRef<Element | null>(null);

  useEffect(() => {
    const element = elementRef.current;
    if (!element) {return;}

    const observer = new IntersectionObserver(([entry]) => {
      if (entry.isIntersecting) {
        onIntersect();
        observer.unobserve(element);
      }
    }, options);

    observer.observe(element);

    return () => {
      observer.disconnect();
    };
  }, [elementRef, onIntersect, options]);

  return elementRef;
};

export default useIntersectionObserver;